import { CrossCircleLg } from '@prenuvo/halo-icon';
import { Container, Icon, List, ListItem, Typography } from '@prenuvo/halo-web';

const ExclusionCriteria = () => (
  <Container className="my-4 border border-none bg-neutral-100 px-3 py-4">
    <Typography variant="h5" as="p" className="text-teal-500">
      Exclusion Criteria
    </Typography>
    <Typography variant="paragraph-sm" as="p" className="py-2 text-teal-500">
      Each subject <b>must not</b>:
    </Typography>
    <List>
      <ListItem
        className={{
          root: 'bg-neutral-100',
        }}
        leadingContent={
          <Icon
            className="fill-current text-red-500"
            source={CrossCircleLg}
            aria-label="check mark circle"
          />
        }
        title={{
          children:
            'Harbor within their bodies contraindicated medical devices including, but not limited to, implanted pacemakers, intracranial aneurysm clips, cochlear implants, drug infusion pumps, neurostimulators, bone growth stimulators, certain intrauterine contraceptive devices, non-MRI safe metals, etc.;',
        }}
      />

      <ListItem
        className={{
          root: 'bg-neutral-100',
        }}
        leadingContent={
          <Icon
            className="fill-current text-red-500"
            source={CrossCircleLg}
            aria-label="check mark circle"
          />
        }
        title={{
          children: 'Self-certify that they are pregnant;',
        }}
      />

      <ListItem
        className={{
          root: 'bg-neutral-100',
        }}
        leadingContent={
          <Icon
            className="fill-current text-red-500"
            source={CrossCircleLg}
            aria-label="check mark circle"
          />
        }
        title={{
          children:
            'Be seeking to undergo WB-MRI as a subject in this study in lieu of other covered dedicated diagnostic imaging evaluations when such covered procedures represent more appropriate or standard-of-care procedures by context-specific clinical indication;',
        }}
      />

      <ListItem
        className={{
          root: 'bg-neutral-100',
        }}
        leadingContent={
          <Icon
            className="fill-current text-red-500"
            source={CrossCircleLg}
            aria-label="check mark circle"
          />
        }
        title={{
          children: 'Be an employee of the study site or the sponsor;',
        }}
      />

      <ListItem
        className={{
          root: 'bg-neutral-100',
        }}
        leadingContent={
          <Icon
            className="fill-current text-red-500"
            source={CrossCircleLg}
            aria-label="check mark circle"
          />
        }
        title={{
          children:
            'Have a medical condition or serious intercurrent illness, or other circumstance that, in the Investigator’s judgment, could jeopardize the candidate’s safety as a study subject, or that could interfere with study objectives.',
        }}
      />
    </List>
  </Container>
);

export default ExclusionCriteria;
